"use strict";

function MembersGrid() {
  const options = {
    localStorageName: "_90dl_pm_members",
    localStorageCacheName: "_90dl_pm_members_cache",
    template: "members-list",
    container: "members-list-rendered",
    sampleSize: 24,
    refreshTime: 300000,
    currentTime: new Date().getTime()
  };

  this.render = args => {
    if (
      !localStorage.getItem(options.localStorageName) ||
      !(
        options.currentTime -
          localStorage.getItem(options.localStorageCacheName) <=
        options.refreshTime
      )
    ) {
      this.setMembers(args);
    } else {
      let members = JSON.parse(this.getMembers());
      if (typeof args === "undefined") {
        args = {
          az: "",
          sector_group: ""
        };
      }

      members = this.filterMembers(members, args);
      let members_obj = {
        members
      };

      let template = Handlebars.compile(
        document.getElementById(options.template).innerHTML
      );
      document.getElementById(options.container).classList.remove("active");

      let rendered = template(members_obj);
      document.getElementById(options.container).innerHTML = rendered;

      setTimeout(function() {
        document.getElementById(options.container).classList.add("active");
      }, 200);
    }
  };

  (this.getMembers = () => {
    let stored_members = localStorage.getItem(options.localStorageName);
    let members_json = JSON.parse(stored_members);
    return members_json;
  }),
    (this.setMembers = args => {
      let request = new XMLHttpRequest();
      request.open("GET", "/wp-json/90dl/v1/get_members/");
      request.onload = () => {
        if (request.status >= 200 && request.status < 400) {
          let membersJson = JSON.stringify(request.responseText);
          localStorage.setItem(options.localStorageName, membersJson);
          localStorage.setItem(
            options.localStorageCacheName,
            new Date().getTime()
          );
          this.render(args);
        } else {
          console.log(
            "Error Code: " + request.status + " - Please check the API"
          );
        }
      };
      request.onerror = () => {
        console.log("Failed to retrieve members from API");
      };

      request.send();
    }),
    (this.filterMembers = (json, args) => {
      // A-Z Filter
      if (args.az.length) {
        if (args.az === "0-9") {
          args.az = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        }
        json = _.filter(json, function(item) {
          return _.some(item.name[0], function(inital) {
            inital = inital.toLowerCase();
            if (_.isArray(args.az)) {
              for (let i = 0; i < args.az.length; i++) {
                if (inital === args.az[i]) {
                  return _.startsWith(inital, args.az[i], 0);
                }
              }
            } else {
              return _.startsWith(inital, args.az, 0);
            }
          });
        });
      }

      // Sector Filter

      if (args.sector_group.length) {
        json = _.filter(json, function(item) {
          return _.some(item["sector-group"], function(sector) {
            if (sector.slug === args.sector_group) {
              return item;
            }
          });
        });
      }

      // Randomise

      if (!args.az.length && !args.sector_group.length) {
        json = _.sampleSize(json, options.sampleSize);
      }

      return json;
    });
}

document.addEventListener("DOMContentLoaded", function(event) {
  const section_container = document.getElementsByClassName(
    "type-members-grid"
  );
  const members_container = document.getElementsByClassName("type-members");
  //if we are on members archive page
  if (section_container.length) {
    let sectorFilter = document.getElementById("member-list__sector-filter");
    let resetFilter = document.getElementsByClassName("filter-reset");
    let azFilter = document.getElementsByClassName("member-list__filter--az");
    azFilter = azFilter[0].children;
    let members_grid = new MembersGrid();

    //handle page reloading to clear filters in storage
    if (window.performance && performance.navigation.type == 1) {
      sessionStorage.setItem("fromMembers", false);
      sessionStorage.setItem("filterType", "");
      sessionStorage.setItem("az", "");
      sessionStorage.setItem("sectorGroup", "");
    }

    //check if we came from a members page
    let fromMembers = sessionStorage.getItem("fromMembers");

    //we came from elsewhere - clear storage and render a new random grid
    if (fromMembers == false) {
      members_grid.render();
    } else {
      //we came from a members page, so load the saved filters
      let args;
      const filterType = sessionStorage.getItem("filterType");
      switch (filterType) {
        case "az":
          const filterState = sessionStorage.getItem("az");
          args = {
            az: filterState,
            sector_group: ""
          };

          let thisFilter = document.querySelectorAll(
            '[data-filter~="' + filterState + '"]'
          )[0];
          handleAzFilter(azFilter, thisFilter);
          showDashboards(filterType);
          break;
        case "sector":
          args = {
            az: "",
            sector_group: sessionStorage.getItem("sectorGroup")
          };
          members_grid.render(args);
          showDashboards(filterType);
          break;
        default:
          members_grid.render();
      }
    }

    // render a new grid based on user's a-z choice
    for (let i = 0; i < azFilter.length; i++) {
      let az = azFilter[i];
      az.addEventListener("click", function() {
        handleAzFilter(azFilter, this);
      });
    }

    // render a new grid based on a user's sector choice
    sectorFilter.addEventListener("change", function() {
      if (this.value !== "DEFAULT") {
        sessionStorage.setItem("filterType", "sector");
        sessionStorage.setItem("sectorGroup", this.value);
        let args = {
          az: "",
          sector_group: this.value
        };
        members_grid.render(args);
      } else {
        members_grid.render();
      }
    });

    function handleAzFilter(azFilter, newFilter) {
      for (let f = 0; f < azFilter.length; f++) {
        const azf = azFilter[f];
        azf.classList.remove("selected");
      }
      newFilter.classList.add("selected");
      let filter = newFilter.dataset.filter;
      sessionStorage.setItem("az", filter);
      sessionStorage.setItem("filterType", "az");
      let args = {
        az: filter,
        sector_group: ""
      };
      members_grid.render(args);
    }

    function showDashboards(type) {
      if (typeof type === "undefined") {
        type = "";
      }
      let dashboards = document.getElementsByClassName("filter-dashboard");

      for (let i = 0; i < dashboards.length; i++) {
        let dashboard = dashboards[i];
        dashboard.classList.remove("active");
        if (dashboard.classList.contains("filter-dashboard__" + type)) {
          dashboard.classList.add("active");
        }
      }
    }

    for (let i = 0; i < resetFilter.length; i++) {
      let reset = resetFilter[i];
      reset.addEventListener("click", function() {
        sessionStorage.setItem("fromMembers", false);
        sessionStorage.setItem("filterType", "");
        sessionStorage.setItem("az", "");
        sessionStorage.setItem("sectorGroup", "");
        for (let f = 0; f < azFilter.length; f++) {
          const azf = azFilter[f];
          azf.classList.remove("selected");
        }
        members_grid.render();
        showDashboards();
      });
    }

    let memberFilters = document.getElementById("member-list-filters-controls");
    memberFilters = memberFilters.children;
    for (let i = 0; i < memberFilters.length; i++) {
      memberFilters[i].addEventListener("click", function(e) {
        let filter_type = this.dataset.filterType;
        showDashboards(filter_type);
        e.preventDefault();
      });
    }
  }
  if (members_container.length) {
    sessionStorage.setItem("fromMembers", true);
  } else if (!section_container.length) {
    sessionStorage.setItem("fromMembers", false);
    sessionStorage.setItem("filterType", "");
    sessionStorage.setItem("az", "");
    sessionStorage.setItem("sectorGroup", "");
  }
});
